<template>
  <v-row v-if="isInspectionLawsuit(caseData)">
    <template>
      <v-col
        cols="12"
        lg="4"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.lawsuitDetails.inspectionCity"
          :value.sync="workCityId"
          :items="cities"
          :disabled="!cities.length || disabled"
          item-value="id"
          item-text="name"
          :validates="'required'"
          @change="workCityChanged"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        lg="4"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.lawsuitDetails.court"
          :value="courtId"
          :items="laborCityCourt[workCityId]"
          item-value="id"
          item-text="name"
          :validates="'required'"
          :disabled="disabled"
          @change="updateCourtId"
        ></naj-input>
      </v-col>
    </template>
  </v-row>
  <v-row v-else>
    <v-col
      cols="12"
      lg="4"
    >
      <naj-input
        :type-id="formFieldType.radioButton"
        :value.sync="isTherePartyPlaceCondition"
        :label="local.lawsuitDetails.isTherePartyPlaceCondition"
        :items="yesNoOption"
        :disabled="disabled"
        item-value="id"
        item-text="name"
        validates="required"
        @change="isTherePartyPlaceConditionChangedEvent"
      ></naj-input>
    </v-col>
    <template v-if="isTherePartyPlaceCondition">
      <v-col
        cols="12"
        lg="4"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="isTherePartyPlaceCondition == yesOrNoEnum.no?local.lawsuitDetails.workCity:local.lawsuitDetails.agreedLawsuitCityUponContract"
          :value.sync="workCityId"
          :items="cities"
          :disabled="!cities.length || disabled"
          item-value="id"
          item-text="name"
          :validates="'required'"
          @change="workCityChanged"
        ></naj-input>
        <span
          v-if="isTherePartyPlaceCondition == yesOrNoEnum.no"
          class="user-attention"
        >
          {{ local.lawsuitDetails.workCityDescription }}
        </span>
      </v-col>

      <v-col
        cols="12"
        lg="4"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.lawsuitDetails.court"
          :value="courtId"
          :items="laborCityCourt[workCityId]"
          item-value="id"
          item-text="name"
          :validates="'required'"
          :disabled="disabled"
          @change="updateCourtId"
        ></naj-input>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { yesOrNoEnum } from '@/helpers/enum';
import { isLaborLawsuit, isInspectionLawsuit } from '../../../helpers/utils';

const { mapState, mapActions } = createNamespacedHelpers('LawsuitModule');
const { mapActions: mapLUTActions, mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');

export default {
  inject: ['$validator'],
  props: ['courtId', 'partiesInfo', 'disabled', 'handleGetCourtsInvoker', 'disableLocationSpecializationRule'],
  data() {
    return {
      isLaborLawsuit,
      isInspectionLawsuit,
      yesOrNoEnum,
      closestCourts: [],
      workCityId: null,
      cityId: null,
      isTherePartyPlaceCondition: null,
    };
  },
  computed: {
    ...mapState({ caseData: state => state.lawsuitRequest.case }),
    ...mapLUTState(['cities', 'laborCityCourt', 'yesNoOption']),
  },
  watch: {
    handleGetCourtsInvoker(invoker) {
      if (invoker)
        this.handleGetCourts(invoker);
    },
    'workCityId': function (value) {
      this.$set(this.caseData, 'workCityId', value);
    },
    'cityId': function (value) {
      this.$set(this.caseData, 'cityId', value);
    },
    'isTherePartyPlaceCondition': function (value) {
      this.$set(this.caseData, 'isTherePartyPlaceCondition', value);
    },
  },
  mounted() {
    this.workCityId = this.caseData.workCityId || null;
    this.cityId = this.caseData.cityId || null;
    this.isTherePartyPlaceCondition = this.caseData.isTherePartyPlaceCondition !== undefined ? this.caseData.isTherePartyPlaceCondition : null;
    this.handleGetCourts('mounted');
  },
  methods: {
    ...mapActions(['getPartiesClosestCourts']),
    ...mapLUTActions(['getCities', 'getCourtByLaborCity']),
    handleGetPartiesClosestCourts(invoker) {
      const caseTypeId = this.caseData.caseTypeId || null;
      const caseCategoryId = this.caseData.caseCategoryId || null;
      const caseClassificationId = this.caseData.caseClassificationIdNew || null;
      const accidentCityId = this.caseData.cityId || null;
      const disableLocationSpecializationRule = this.disableLocationSpecializationRule || null;
      const isRelatedToCorona = this.caseData.isRelatedToCorona || null;
      if (caseTypeId && caseCategoryId && caseClassificationId && (this.partiesInfo || []).length) {
        const data = {
          invoker,
          caseTypeId,
          caseCategoryId,
          caseClassificationId,
          disableLocationSpecializationRule,
          accidentCityId,
          isRelatedToCorona,
          partiesInfo: this.partiesInfo,
          form: (this.caseData.forms || [])[0],
        };
        this.getPartiesClosestCourts(data)
          .then(({ data }) => {
            this.closestCourts = data.data;
            this.$emit('courtsRetrieved', this.closestCourts);
          });
      }
    },
    isTherePartyPlaceConditionChangedEvent() {
      this.$set(this, 'workCityId', null);
      this.updateCourtId(null);
      this.handleGetCourts('isTherePartyPlaceConditionChangedEvent');
    },
    workCityChanged(value) {
      if (value) {
        this.updateCourtId(null);
        this.getCourtByLaborCity(value)
          .then((cityCourt) => {
            this.updateCourtId((cityCourt || [{ id: null }])[0].id);
          });
      }
    },
    handleGetCourts(invoker) {
      if (this.isLaborLawsuit(this.caseData)) {
        this.getCities();
        if (this.workCityId)
          this.getCourtByLaborCity(this.workCityId);
      }
      else
        this.handleGetPartiesClosestCourts(invoker);
    },
    updateCourtId(courtId) {
      this.$emit('update:courtId', courtId);
      this.$emit('change', courtId);
    },
  },
};
</script>

<style lang="scss" scoped>
.user-attention {
  font-size: 14px;
  color: red;
  font-weight: bold;
}
</style>
